var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visiable
    ? _c("div", { staticClass: "dialog" }, [
        _c("div", { staticClass: "shade" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dialog_body", staticStyle: { height: "80%" } },
          [
            _c("div", { staticClass: "title" }, [
              _c("span", [_vm._v(_vm._s(_vm.title))])
            ]),
            _vm._v(" "),
            _vm.closable
              ? _c("div", { staticClass: "icon" }, [
                  _c("div", {
                    staticClass: "iconfont icon-close",
                    on: { click: _vm.close }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.subhead
              ? _c("div", { staticClass: "subhead" }, [
                  _vm._v(_vm._s(_vm.subhead))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "short-line" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content",
                staticStyle: { height: "100%" },
                attrs: { name: "content" }
              },
              [
                _c("p", {
                  staticStyle: { color: "red" },
                  domProps: { innerHTML: _vm._s(_vm.tips) }
                }),
                _vm._v(" "),
                _vm._t("content", [_vm._v(_vm._s(_vm.content))])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "buttongroup" }, [
              _c(
                "div",
                {
                  staticClass: "button cancel",
                  on: { click: _vm.cancleMethod }
                },
                [_vm._v(_vm._s(_vm.cancel || "取消"))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "button confirm",
                  on: { click: _vm.confirmMethod }
                },
                [_vm._v(_vm._s(_vm.confirm || "确认"))]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-229ee358", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229ee358","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog.vue
// module id = null
// module chunks = 